import React, { useMemo, useState, useEffect } from 'react';
import {
  getAggregatedAddress,
  getProductPrice,
  getPromoPrice,
  getValid$Cost,
  getWirelessServRef,
} from '../../../common/common';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import WhiPlans from './WhiPlans';
import StaticResultsView from './StaticResultsView';
import { getWhiPerkItems } from './whiPerkItems';
import {
  getServicePropsByCode,
  saveInternetPlan,
  saveVasPlanInfo,
  saveWirelessPlanInfo,
  setMBoxReqObj,
  setSelectedBundle,
  setSelectedProduct,
  updateOrder,
  saveFirstStep,
} from '../../../store/action/OrderAction';
import { resolveServiceDesc, getPlanName, resolveSpeedDisclaimer } from '../../../helpers/planTranslations';
import {
  useBusinessAddr,
  useCallCenterFlag,
  useSinglePageCheckoutNow,
  useCartData,
  useMbox,
  useSessionData,
} from '../../../hooks/order';
import {
  EECproductAddToCart,
  EECproductRemoveFromCart,
  trackTfnClick,
} from '../../../common/GTMScripts';
import useLeadsSDK from '../../../hooks/useLeadsSDK';
import PropTypes from 'prop-types';
import EarthlinkPerks from './EarthlinkPerks';
import FiberTrustSection from './FiberTrustSection';
import BusinessSpeedInfoCard from './BusinessSpeedInfoCard';
import FixedWirelessHeaderSection from './BusinessHeaderSection';
import InternetResultHeading from './InternetResultHeading';
import { routesConfig, OrderStatus, isATTVendor, isTMOVendor } from '../../../util/util';
import './InternetPlans.scss';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

import PlanSlider from './PlanSlider';
import { DownloadUploadSpeedIcon, UnlimitedDataIcon, CustomerSupportIcon, LifeLockIcon, CalendarIcon } from '../../../images/svg';
import BusinessContact from './BusinessContact';
import { ensureTrailingPeriod, normalizeUnitCasing } from '../../../helpers/text';
import { getProductLabel, getConsumerPlanName, isFiberServiceable } from '../../../helpers/productLabels';
import { getCurrentTfn, filterFixedWirelessProducts } from '../../../helpers/tfn';
import { useFFReferralSession } from '../../../hooks/useFFReferralSession';
import { useTranslation } from 'react-i18next';

const ProductPlanCard = ({
  wrapperClass,
  innerClass,
  header,
  features,
  showCallNow,
  callNowIcon,
  phoneNumber,
  isInternetAdded,
  isSelected,
  onAddOrRemove,
  cartWrapperClass,
  isBusinessAddress,
  label,
  productCategory,
  speedTier,
}) => {
  const { t } = useTranslation();
  const [viewDetails, setViewDetails] = useState(false);

  return (
    <div className={wrapperClass}>
      <div className={innerClass}>
        <div className="elnk-plan-top-bar">{label}</div>
        {header}

        <div className="plans-body">
          <ul className={`elnk-plan-feature-list ${viewDetails || (features && features.length <= 2) ? 'elnk-plan-feature-list-open' : ''}`}>
            {features && features?.length > 2 && !viewDetails
              ? features.slice(0, 2)
              : features}
          </ul>
          {features && features?.length > 2 && (
            <div className="view-details-link" onClick={() => setViewDetails(!viewDetails)}>
              {viewDetails ? t('common.hideDetails') : t('common.viewDetails')}
            </div>
          )}
        </div>

        <div className="plans-footer">
          {!showCallNow ? (
            <div className={cartWrapperClass}>
              <button
                className={`blue-button ${isInternetAdded ? 'grey-button' : ''}`}
                disabled={isInternetAdded && !isSelected}
                onClick={onAddOrRemove}
              >
                <i
                  className={`fa-solid ${isSelected ? 'fa-solid fa-arrows-rotate fa-spin' : 'fa-solid fa-cart-shopping'
                  }`}
                ></i>
                {isSelected ? t('common.addingToCart') : t('common.selectPlan')}{' '}
              </button>
            </div>
          ) : (
            <div className="agent-call-button">
              <a
                href={`tel:${phoneNumber}`}
                className="blue-button elnk-tfn-link"
                onClick={() => trackTfnClick({ productCategory, speedTier })}
              >
                <i className={callNowIcon}></i>
                <span className="phone-span elnk-tfn-tag">{phoneNumber}</span>
              </a>
              {isBusinessAddress && (
                <div className="book-meeting-line" >
                  <button
                    onClick={() =>
                      window.open(
                        'https://outlook.office.com/book/BusinessInternetConsultation@elnk.com',
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                  >
                    {t('products.bookMeeting')}
                  </button>
                </div>
              )}
            </div>
          )}
        </div>

      </div>
    </div>
  );
};


const InternetPlans = (props) => {
  const { t , i18n} = useTranslation();
  const leads = useLeadsSDK();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const {
    serviceabilityCheck,
    productTfn,
    invocaTfn,
    normalizedAddress,
    onResetAddress,
  } = props;

  // serviceabilityCheck already carries the Friends & Family catalog when the session is one:
  // Product.js narrows it once and hands it down. This component used to re-filter it three
  // more times with two different rule sets, which is how the carousel, the sorted list and
  // the card grid could each show a different set of plans.
  const { plans: rawPlans, serviceTerm, fixedWirelessProducts: rawFixedWirelessProducts, fixedWireless } = serviceabilityCheck;
  const isFFFlow = useFFReferralSession();

  const plans = useMemo(() => rawPlans || [], [rawPlans]);

  const hasFiberPlans = useMemo(
    () => plans.some(isFiberServiceable),
    [plans],
  );

  const fixedWirelessProducts = useMemo(
    () => filterFixedWirelessProducts(rawFixedWirelessProducts, fixedWireless),
    [rawFixedWirelessProducts, fixedWireless],
  );

  const { customTFN, orderInfo , referrer} = useSessionData();
  const isWinterPromo = true;
  const [viewDetails, setViewDetails] = useState({});

  const toggleViewDetails = (servRef) => {
    setViewDetails((prev) => ({
      ...prev,
      [servRef]: !prev[servRef],
    }));
  };

  // const [showFilteredPlans, setShowFilteredPlans] = useState(true);
  const {
    internetPlan = {},
    selectedBundleData,
    isBundleAdded,
    sortedData,
    productsWith12MonthFixWirelessServCode,
    spanishLanguagePref
  } = useCartData();
  const { mboxRequired } = useMbox();
  const isInternetAdded = Object.keys(internetPlan).length > 0;
  const { showCallNow, showPromoStickers, isAlwaysOnReferrer } = useCallCenterFlag();
  const isSinglePageCheckoutNow = useSinglePageCheckoutNow();
  const { isBusinessAddress } = useBusinessAddr();

  useEffect(() => {
    dispatch(saveInternetPlan({}));
  }, [dispatch]);
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);



  const { referrer: referrerQuery = '' } = queryString.parse(location.search);
  const referrerUri = (referrerQuery || referrer || '')?.toString();
  const handleAddIntToCart = (product) => {
    dispatch(getServicePropsByCode(product.servCode)).then((res) => {
      mboxRequired[product.servCode] =
        res.action?.payload?.data?.item?.isMboxReq;
      dispatch(setMBoxReqObj(mboxRequired));
    });
    dispatch(saveInternetPlan(product));
    EECproductAddToCart(product);
    leads?.updateOrder?.('add internet product to cart', {
      products: [
        {
          data: {
            category: 'internet',
            contractLength: product?.contractLength,
            downstreamSpd: product?.downstreamSpd,
            ebbInstallationCost: product?.ebbInstallationCost,
            ebbShippingCost: product?.ebbShippingCost,
            equipmentCost: product?.equipmentCost,
            upstreamSpd: product?.upstreamSpd,
          },
          id: String(product?.servRef),
          name: product?.serviceName,
          price: String(product?.price),
          quantity: 1,
        },
      ],
    });
  };

  // A CSI (address-contingent) plan is added like any other - no Self/Professional choice.
  // Every checkout is the single-page checkout, which makes a CSI plan self install
  // (useCsiSelfInstallDefault), so a Professional pick here could only be overridden.
  const addIntToCart = (product) => {
    if (isInternetAdded) {
      if (isBundleAdded && selectedBundleData?.category !== 'mobile') {
        dispatch(
          saveVasPlanInfo({
            vasPlan: [],
            vasProductCart: [],
          }),
        );
        dispatch(
          saveWirelessPlanInfo({
            wirelessPlanInfo: [],
            wirelesServeRef: getWirelessServRef([]),
          }),
        );
        dispatch(setSelectedBundle(null));
      }

      delete mboxRequired[product.servCode];
      dispatch(setMBoxReqObj(mboxRequired));
      EECproductRemoveFromCart(product);
      dispatch(saveInternetPlan({}));

      /**
       * Remove internet product from cart
       */
      leads?.updateOrder?.('remove internet product from cart', {
        products: [
          {
            id: String(product?.servRef),
            name: product?.serviceName,
            quantity: 0,
          },
        ],
      });
    } else {
      if (
        product.servCode?.toLowerCase() === 'elfw' &&
        !isBusinessAddress
      ) {
        dispatch(setSelectedProduct(product));
      }
      handleAddIntToCart(product);
      if (isSinglePageCheckoutNow()) {navigateToCheckout(product);}
    }
  };

  const navigateToCheckout = (product) => {
    const servRef = product?.servRef;
    const orderAccessToken = orderInfo?.orderAccessToken || '';

    if (!orderAccessToken) {
      return;
    }

    dispatch(updateOrder({
      orderStatus: OrderStatus.addedToCart,
      serviceReference: servRef
    }, orderAccessToken));
    dispatch(saveFirstStep(true));

    setTimeout(() => {
      navigate(routesConfig.checkout);
    }, 100);
  };

  const customTfn = () => invocaTfn || getCurrentTfn({
    referrerUri,
    fixedWirelessProducts,
    plans,
    productsWith12MonthFixWirelessServCode,
    isBusinessAddress,
    customTFN,
    fallbackTfn: productTfn,
  });

  const currentTfn = customTfn();

  // Always include both sets (no toggle)
  const combinedWhiAndFixWirelessProducts = [
    ...(fixedWirelessProducts || []),
    ...(productsWith12MonthFixWirelessServCode || []),
  ];

  const businessCards = combinedWhiAndFixWirelessProducts?.map((data) => {
    let serviceDesc = '';
    const isViewDetailsOpen = viewDetails[data.servRef] || false;

    const isWhiProduct = Array.isArray(fixedWirelessProducts) && fixedWirelessProducts.includes(data);

    const englishDesc = isWhiProduct ? data?.serviceDescription : data?.serviceDesc; // For whiProducts / productsWith12MonthFixWirelessServCode
    const spanishDescEncoded = isWhiProduct ? data?.serviceDescriptionEsp : data?.serviceDescEsp;

    serviceDesc = resolveServiceDesc(spanishLanguagePref, spanishDescEncoded, englishDesc);

    const iconMap = [DownloadUploadSpeedIcon, UnlimitedDataIcon, CustomerSupportIcon, LifeLockIcon, CalendarIcon];

    const serviceDescList = serviceDesc
      ?.split(/\. (?=\D)/) // Split only on ". " followed by a non-digit character
      .filter((item) => item !== '')
      .map((listItem, descIndex) => {
        const Icon = descIndex < 5 ? iconMap[descIndex] : null;
        const uniqueKey = `${data?.servRef || ''}-desc-${descIndex}-${listItem.slice(0, 10)}`;
        return (
          <li key={uniqueKey} className={Icon ? 'plan-feature-item' : ''}>
            {Icon && <span className="plan-feature-icon"><Icon /></span>}
            <p>{ensureTrailingPeriod(normalizeUnitCasing(listItem))}</p>
          </li>
        );
      });

    return (
      <div key={data.servRef} className="plan-single">
        <div className={'plan-single-inner'}>
          <div className="elnk-plan-top-bar">{getProductLabel(data, t)}</div>
          <div className="plans-header">
            {/* <div className="business-plans-header-full-info"> */}
            <BusinessSpeedInfoCard speed={
              data?.downstreamSpd &&
                data?.downstreamSpd / 1000
            } />
            <h4 className="plans-header__title">
              {data?.shortName
                ?.replace(/Fixed Wireless\s?/i, '')
                ?.replace(/(\d+)mo/i, '$1month')
                ?.replace(/(\d+)(MB|GB)/i, '$1 $2')
                ?.split(/(\d+month)/i)
                .map((part, index) => (
                  /\d+mo/i.test(part) ? (
                    <span key={index} className="small-text">{part}</span>
                  ) : (
                    <React.Fragment key={index}>{part}</React.Fragment>
                  )
                ))}
            </h4>
            {!isBusinessAddress && (
              <div className="plans-header__price">
                {getPromoPrice(data, serviceTerm) && (
                  <span className="discount">
                    {getValid$Cost(data.price)}
                  </span>
                )}
                <span className="total-single">
                  {getPromoPrice(data, serviceTerm)
                    ? getPromoPrice(data, serviceTerm)
                    : getValid$Cost(data.price)}{' '}
                  / mo
                </span>
              </div>
            )}
            {/* </div> */}
          </div>
          <div className="plans-body">
            <ul className={`elnk-plan-feature-list ${isViewDetailsOpen || (serviceDescList && serviceDescList.length <= 2) ? 'elnk-plan-feature-list-open' : ''}`}>
              {serviceDescList && serviceDescList?.length > 2 && !isViewDetailsOpen
                ? serviceDescList.slice(0, 2)
                : serviceDescList}
            </ul>
            {serviceDescList && serviceDescList?.length > 2 && (
              <div className="view-details-link" onClick={() => toggleViewDetails(data.servRef)}>
                {isViewDetailsOpen ? t('common.hideDetails') : t('common.viewDetails')}
              </div>
            )}
          </div>

          <div className="plans-footer">
            {(showCallNow || isBusinessAddress) ? (
              <div className="agent-call-button">
                <a
                  href={`tel:${currentTfn}`}
                  className="blue-button elnk-tfn-link"
                >
                  <i className="fa-solid fa-mobile-screen-button"></i>{' '}
                  <span className="phone-span elnk-tfn-tag">
                    {currentTfn}
                  </span>
                </a>

                {isBusinessAddress && (
                  <div className="book-meeting-line">
                    <button
                      onClick={() =>
                        window.open(
                          'https://outlook.office.com/book/BusinessInternetConsultation@elnk.com',
                          '_blank',
                          'noopener,noreferrer'
                        )
                      }
                    >
            Book a meeting
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className="down-cart d-flex al-center j-between">
                <button
                  className={`blue-button ${isInternetAdded && 'grey-button'}`}
                  disabled={
                    isInternetAdded &&
          internetPlan.servRef !== data.servRef
                  }
                  onClick={() => {
                    addIntToCart(data);
                    dispatch(setSelectedProduct(data));
                  }}
                >
                  <i
                    className={`fa-solid ${
                      isInternetAdded && internetPlan.servRef === data.servRef
                        ? 'fa-times'
                        : 'fa-cart-shopping'
                    }`}
                  ></i>

                  {isInternetAdded && internetPlan.servRef === data.servRef
                    ? t('common.remove')
                    : t('common.selectPlan')}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  });

  // const showMostPopular = (i, product) => {
  //   const { downstreamSpd = 0 } = product;
  //   const productSpd = downstreamSpd / 1000 === 300;
  //   const vendor = vendorInformation(product, extendedInfo);

  //   if (vendor.toLowerCase() === 'at&t' && productSpd) {
  //     return 'mostPop';
  //   }
  //   if (
  //     i.toString() ===
  //     `${showCallNow || showPromoStickers ? displayedPlans.length - 1 : '0'
  //     }` &&
  //     !productSpd300
  //   ) {
  //     return 'mostPop';
  //   }
  //   return '';
  // };

  const allplansClass = () => {
    if (showPromoStickers) {
      return 'promo-sticker';
    } else if (plans.length) {
      return 'internet-promo';
    }
  };
  const convertSpeedUnit = (speed) => {
    if (speed?.toLowerCase().includes('mb')) {
      return speed.replace(/mb/i, ' Mbps');
    } else if (speed?.toLowerCase().includes('gb')) {
      return speed.replace(/gb/i, ' Gbps');
    }
    return speed;
  };

  const pathname =
    '/' +
    window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
  const displayedPlans = useMemo(
    () => (sortedData?.length ? sortedData : (plans || [])),
    [sortedData, plans],
  );

  const residentialData = useMemo(
    () => ((plans?.length > 0 && fixedWirelessProducts?.length > 0) ? plans : displayedPlans),
    [plans, fixedWirelessProducts, displayedPlans],
  );

  const sortedResidentialData = useMemo(() => {
    if (!residentialData) {return [];}
    const is1Gig = (speed) => speed === '1 Gbps' || speed === '1000 Mbps';
    return [...residentialData].sort((a, b) => {
      const aSpeed = convertSpeedUnit(a?.downstreamSpeed);
      const bSpeed = convertSpeedUnit(b?.downstreamSpeed);
      if (aSpeed === '500 Mbps' && bSpeed !== '500 Mbps') {return -1;}
      if (bSpeed === '500 Mbps' && aSpeed !== '500 Mbps') {return 1;}
      if (is1Gig(aSpeed) && !is1Gig(bSpeed)) {return -1;}
      if (is1Gig(bSpeed) && !is1Gig(aSpeed)) {return 1;}
      return 0;
    });
  }, [residentialData]);

  const residentialCards = useMemo(() => {
    const totalCount = (sortedResidentialData?.length || 0) + (fixedWirelessProducts?.length || 0);
    const centerIndex = Math.floor(totalCount / 2);

    return sortedResidentialData?.map((product, index) => {
      const iconMap = [DownloadUploadSpeedIcon, UnlimitedDataIcon, CustomerSupportIcon, LifeLockIcon, CalendarIcon];

      const serviceDescSource = resolveServiceDesc(spanishLanguagePref, product?.serviceDescEsp, product?.serviceDesc);

      const serviceDesc = serviceDescSource
        ?.split('.')
        .filter(Boolean)
        .map((listItem, descIndex) => {
          const Icon = descIndex < 5 ? iconMap[descIndex] : null;

          return (
            <li key={`${product.servRef}-desc-${descIndex}`} className={'plan-feature-item'}>
              {Icon && <span className="plan-feature-icon"><Icon /></span>}
              <p>{ensureTrailingPeriod(normalizeUnitCasing(listItem))}</p>
            </li>
          );
        });

      const isSelected =
      isInternetAdded && internetPlan.servRef === product.servRef;

      const promoPrice = getPromoPrice(product, serviceTerm);
      const regularPrice = getProductPrice(product , serviceTerm)
      const displayPrice = promoPrice || getProductPrice(product, serviceTerm);
      const hasPromoPrice = Boolean(promoPrice);
      const isCentered = totalCount <= 3 && index === centerIndex;

      return (
        <ProductPlanCard
          key={product.servRef}
          label={getProductLabel(product, t, true)}
          wrapperClass={`plan-single ${
            convertSpeedUnit(product?.downstreamSpeed) === '500 Mbps'
              ? 'highlighted'
              : ''
          } ${isCentered ? 'centered' : ''}`}
          innerClass="plan-single-inner"
          header={
            <div className="plans-header">
              <h4 className="plans-header__title">
                {/* {product?.downstreamSpeed &&
                convertSpeedUnit(product?.downstreamSpeed)} */}
                {getConsumerPlanName(product, t) || getPlanName({plan: product , spanishLanguagePref})}
              </h4>

              {!showCallNow && (
                <div className="plans-header__price-wrap">
                  { hasPromoPrice && regularPrice !== displayPrice && <span className="plans-header__discount_price">{regularPrice}</span>}
                  <h5 className="plans-header__price">{displayPrice} / mo*</h5>
                </div>
              )}
            </div>
          }
          features={serviceDesc}
          showCallNow={showCallNow || isBusinessAddress}
          callNowIcon="fa-solid fa-phone-volume"
          phoneNumber={currentTfn}
          isBusinessAddress={isBusinessAddress}
          isInternetAdded={isInternetAdded}
          isSelected={isSelected}
          onAddOrRemove={() => addIntToCart(product)}
          cartWrapperClass={`down-cart d-flex al-center j-between ${
            showPromoStickers ? '' : 'show-promo'
          }`}
          regularPrice={regularPrice}
          displayPrice={displayPrice}
          hasPromoPrice={hasPromoPrice}
          productCategory="fiber"
          speedTier={convertSpeedUnit(product?.downstreamSpeed)}
        />
      );
    });
  }, [
    sortedResidentialData,
    isInternetAdded,
    internetPlan.servRef,
    serviceTerm,
    showCallNow,
    showPromoStickers,
    fixedWirelessProducts,
    isBusinessAddress,
    currentTfn,
    spanishLanguagePref,
    i18n.language
  ]);

  const fixedWirelessCards = fixedWirelessProducts &&
    fixedWirelessProducts.length > 0 &&
    fixedWirelessProducts.map((data, index) => {
      let serviceDesc = '';
      const iconMap = [DownloadUploadSpeedIcon, UnlimitedDataIcon, CustomerSupportIcon, LifeLockIcon, CalendarIcon];

      const fwDescSource = resolveServiceDesc(spanishLanguagePref, data?.serviceDescriptionEsp, data?.serviceDescription);

      serviceDesc = fwDescSource
        ?.split('.')
        .map((item) => item?.trim())
        .filter(Boolean)
        .map((listItem, fwIndex) => {
          const Icon = fwIndex < 5 ? iconMap[fwIndex] : null;
          const uniqueKey = `${data.servRef}-fw-desc-${fwIndex}-${listItem.slice(0, 10)}`;
          return (
            <li
              key={uniqueKey}
              className={Icon ? 'plan-feature-item' : ''}
            >
              {Icon && (
                <span className="plan-feature-icon">
                  <Icon />
                </span>
              )}
              <p>{ensureTrailingPeriod(normalizeUnitCasing(listItem))}</p>
            </li>
          );
        });

      const isSelected = isInternetAdded && internetPlan.servRef === data.servRef;
      const promoPrice = getPromoPrice(data, serviceTerm);
      const displayPrice = promoPrice || (isFFFlow ? getProductPrice(data, serviceTerm) : getValid$Cost(data.price));
      const totalCount = (residentialData?.length || 0) + (fixedWirelessProducts?.length || 0);
      const globalIndex = (residentialData?.length || 0) + index;
      const centerIndex = Math.floor(totalCount / 2);
      const isCentered = totalCount <= 3 && globalIndex === centerIndex;

      return (
        <ProductPlanCard
          key={data.servRef}
          label={getProductLabel(data, t, true)}
          wrapperClass={`plan-single ${isCentered ? 'centered' : ''}`}
          innerClass="plan-single-inner"
          header={
            <div className="plans-header">
              <h4 className="plans-header__title plans-header__title--center">
                {/* {data.serviceName.replace('plan', '').replace('Plan', '')} */}
                {getConsumerPlanName(data, t) || getPlanName({plan : data , spanishLanguagePref})}
              </h4>
              {!showCallNow && (
                <h5 className="plans-header__price">{displayPrice} / mo*</h5>
              )}
            </div>
          }
          features={serviceDesc}
          showCallNow={showCallNow}
          callNowIcon="fa-solid fa-phone-volume"
          phoneNumber={currentTfn}
          isInternetAdded={isInternetAdded}
          isSelected={isSelected}
          onAddOrRemove={() => {
            addIntToCart(data);
            dispatch(setSelectedProduct(data));
          }}
          cartWrapperClass={`down-cart d-flex al-center j-between ${showPromoStickers ? '' : 'show-promo'
          }`}
          regularPrice={isFFFlow ? getProductPrice(data, serviceTerm) : getValid$Cost(data?.price)}
          displayPrice={displayPrice}
          hasPromoPrice={Boolean(promoPrice)}
          productCategory="5G"
        />
      );
    });

  const combinedResidentialCards = [...(residentialCards || []), ...(fixedWirelessCards || [])];


  const desktopSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0px',
    arrows: true,
  };

  const tabletSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
  };

  const mobileSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    rows: 2,
    slidesPerRow: 1,
    slidesToScroll: 1,
    arrows: true,
  };
  const planSliderSettings =
  screenWidth < 767
    ? mobileSettings
    : screenWidth < 992
      ? tabletSettings
      : desktopSettings;
  return (
    <>
      <div className="internet-gift-card-section">
        {isWinterPromo ? (
          ''
        ) : fixedWirelessProducts.length === 0 && pathname === '/products' ? (
          <div>
            Use code <span>FIBER24 </span>to receive a $200 gift card**
          </div>
        ) : null}
      </div>

      {(combinedWhiAndFixWirelessProducts?.length > 0 && isBusinessAddress) ? (
        businessCards?.length === 1 ? (
          <>
            <WhiPlans
              fixedWirelessProducts={combinedWhiAndFixWirelessProducts}
              showCallNow={showCallNow}
              phoneNumber={customTfn()}
              isInternetAdded={isInternetAdded}
              internetPlan={internetPlan}
              addIntToCart={addIntToCart}
              dispatch={dispatch}
              getAggregatedAddress={getAggregatedAddress}
              normalizedAddress={normalizedAddress}
              onResetAddress={onResetAddress}
              serviceTerm={serviceTerm}
              showPromoStickers={showPromoStickers}
              isSelected={isInternetAdded}
              isBusinessAddress={true}
              spanishLanguagePref={spanishLanguagePref}
            />
            <BusinessContact />
          </>
        ) : (
          <>
            <div className="elnk-internet-plans-section">
              <FixedWirelessHeaderSection
                getAggregatedAddress={getAggregatedAddress}
                normalizedAddress={normalizedAddress}
                onResetAddress={onResetAddress}
              />
              <div className={'all-single-plans internetOuterClass promo-sticker'}>
                <div className="elink-container">
                  <PlanSlider
                    items={businessCards}
                    sliderSettings={planSliderSettings}
                    wrapperClass="plans-carousel"
                    flexGap="20px"
                  />
                </div>
              </div>
            </div>
            <BusinessContact />
            {/* <ReviewCarousel showCallNow={showCallNow} /> */}
          </>
        )
      ) : plans.length === 0 && fixedWirelessProducts?.length > 0 ? (
        // ELNKWEB-3210: the 5G-only state used to render a single WhiPlans card. It now shows
        // the same three-card comparison as the not-serviceable state - the doc requires the
        // two to be identical - so the customer sees a choice and calls. Note this replaces a
        // working self-serve add-to-cart path with a call-only one, deliberately.
        // WhiPlans is still the business-address renderer above.
        // ELNKWEB-3286: halo.earthlink.net visitors are exempt and can buy online 24/7.
        isAlwaysOnReferrer ? (
          <WhiPlans
            fixedWirelessProducts={fixedWirelessProducts}
            showCallNow={showCallNow}
            phoneNumber={customTfn()}
            isInternetAdded={isInternetAdded}
            internetPlan={internetPlan}
            addIntToCart={addIntToCart}
            dispatch={dispatch}
            getAggregatedAddress={getAggregatedAddress}
            normalizedAddress={normalizedAddress}
            onResetAddress={onResetAddress}
            serviceTerm={serviceTerm}
            showPromoStickers={showPromoStickers}
            isSelected={isInternetAdded}
            isBusinessAddress={false}
            spanishLanguagePref={spanishLanguagePref}
          />
        ) : (
          <>
            <StaticResultsView
              phoneNumber={currentTfn}
              address={normalizedAddress ? getAggregatedAddress(normalizedAddress) : ''}
              onResetAddress={onResetAddress}
              productCategory="5G"
            />
            <EarthlinkPerks phoneNumber={currentTfn} perkItems={getWhiPerkItems(t)} />
          </>
        )
      ) : (
        <>
          <section className="elnk-internet-plans-section">
            <InternetResultHeading
              fixedWireless={fixedWireless}
              fixedWirelessProducts={fixedWirelessProducts}
              plans={plans}
              isATTVendor={isATTVendor}
              isTMOVendor={isTMOVendor}
              isBusinessAddress={isBusinessAddress}
              getAggregatedAddress={getAggregatedAddress}
              normalizedAddress={normalizedAddress}
              onResetAddress={onResetAddress}
              currentTfn={currentTfn}
            />
            <div className={`all-single-plans internetOuterClass ${allplansClass()}`}>
              <div className="elink-container">
                {/* All plans data */}
                <PlanSlider
                  items={combinedResidentialCards}
                  sliderSettings={planSliderSettings}
                  wrapperClass="plans-carousel"
                  flexGap="20px"
                />
              </div>
            </div>
          </section>
          {/* {fixedWirelessProducts?.length === 0 ? ( */}
          <>
            {isBusinessAddress ? (
              <BusinessContact />
            ) : hasFiberPlans ? (
              <FiberTrustSection phoneNumber={currentTfn} speedDisclaimer={resolveSpeedDisclaimer(plans?.[0]?.speedDisclaimer, t)} />
            ) : (
              <EarthlinkPerks showCallNow={showCallNow} phoneNumber={currentTfn} perkItems={getWhiPerkItems(t)} />
            )}
            {/* <ReviewCarousel showCallNow={showCallNow} /> */}
          </>
          {/* ) : null} */}

        </>
      )}
    </>
  );
};

InternetPlans.propTypes = {
  serviceabilityCheck: PropTypes.object.isRequired,
  productSpd300: PropTypes.bool.isRequired,
  productTfn: PropTypes.string.isRequired,
  invocaTfn: PropTypes.string,
  normalizedAddress: PropTypes.object.isRequired,
  onResetAddress: PropTypes.func.isRequired,
};

export default InternetPlans;
